import { useDispatch } from 'react-redux';
import { push } from 'redux-first-history';
import { safelyEncodeBase64Url } from '@dev/ee-tools';

import { ALL_CONTACTS_SEGMENT } from '@/services/constants';
import { ContactsPaths, pathsParams } from '@/services/dictionaries/Paths';
import { useSelectedEntity } from '../../../hooks';
import { useAddContactsToList } from './tableMenuActions/useAddContactsToList';
import { useAddRandomNthList } from './tableMenuActions/useAddRandomNthList';
import { useChangeConcent } from './tableMenuActions/useChangeConcent';
import { useChangeContactsStatus } from './tableMenuActions/useChangeContactsStatus';
import { useCopyEntity } from './tableMenuActions/useCopyEntity';
import { useDelateSelectedEntity } from './tableMenuActions/useDelateSelectedEntity';
import { useDeleteContactsFromList } from './tableMenuActions/useDeleteContactsFromList';
import { useExportsContacts } from './tableMenuActions/useExportsContacts';
import { useRemoveFromList } from './tableMenuActions/useRemoveFromList';

export const useTableMenuActions = () => {
    const dispatch = useDispatch();
    const { selectedEntity, getDisplayName, isSelectedEntityAList } = useSelectedEntity();
    const isList = isSelectedEntityAList(selectedEntity);
    const selectedEntityName = getDisplayName(ALL_CONTACTS_SEGMENT);

    //actions
    const { deleteSelectedEntity } = useDelateSelectedEntity();
    const { deleteContactsFromList } = useDeleteContactsFromList();
    const { copyListOrSegment } = useCopyEntity();
    const { exportContacts } = useExportsContacts();
    const { addRandomNthList } = useAddRandomNthList();
    const { changeConsentTracking } = useChangeConcent();
    const { removeEmailsFromList } = useRemoveFromList();
    const { changeContactsStatus } = useChangeContactsStatus();
    const { addContactToList } = useAddContactsToList();

    const tableMenuActions = (option: string, email?: string): void => {
        const name = safelyEncodeBase64Url(selectedEntityName);

        const availableOptins = {
            edit: () =>
                isList
                    ? dispatch(push(ContactsPaths.ListEditor.replace(pathsParams.listName, name)))
                    : dispatch(push(ContactsPaths.SegmentEditor.replace(pathsParams.segmentName, name))),
            delete: () => deleteSelectedEntity(),
            deletecontacts: () => deleteContactsFromList(email),
            copy: () => copyListOrSegment(),
            exportselected: () => exportContacts(),
            export: () => exportContacts(false),
            randomlist: () => addRandomNthList(true),
            nthselectionlists: () => addRandomNthList(false),
            changeconsenttracking: () => changeConsentTracking(email),
            removefromlist: () => removeEmailsFromList(email),
            changestatus: () => changeContactsStatus(email),
            addtolist: () => addContactToList(false, email),
            addcontacts: () => dispatch(push(ContactsPaths.ListAdd.replace(pathsParams.listName, name))), //listname from useParams
            uploadcontacts: () => dispatch(push(ContactsPaths.ListUpload.replace(pathsParams.listName, name))), //listname from useParams
        };

        return availableOptins?.[option]();
    };

    return { tableMenuActions };
};
